module.exports = __webpack_public_path__ + "assets/img/20_154_big.76a11fb2.jpg";